// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","389":"4fb9382f","455":"3bef4cb2","857":"44f4b707","977":"23814c44"}[chunkId] + ".chunk.js";
};